import type { NavigationScreen } from 'app/types/navigation';
import { usePageTitle, useUISize } from 'app/utils/web-helpers';
import { useEffect } from 'react';
import { BorrowerNextScreen as BorrowerNextScreenLarge } from './borrower-next.large';
import { BorrowerNextScreen as BorrowerNextScreenSmall } from './borrower-next.small';

const BorrowerNextScreenInner: NavigationScreen<'borrowerNext'> = (props) => {
  const { isSmallUI } = useUISize();
  const setPageTitle = usePageTitle('borrowerNext');
  useEffect(() => setPageTitle('headerTitle'), [setPageTitle]);

  if (isSmallUI) {
    return <BorrowerNextScreenSmall {...props} />;
  }
  return <BorrowerNextScreenLarge {...props} />;
};

export const BorrowerNextScreen = BorrowerNextScreenInner;
